type AudioVolumeState = {
  musicVolumePercent: number;
  sfxVolumePercent: number;
};

type ToggleAudioMuteOptions = AudioVolumeState & {
  lastAudibleMusicVolumePercent: number;
  lastAudibleSfxVolumePercent: number;
};

export function isAudioMuted({ musicVolumePercent, sfxVolumePercent }: AudioVolumeState): boolean {
  return musicVolumePercent === 0 && sfxVolumePercent === 0;
}

export function toggleAudioMutedVolumes({
  musicVolumePercent,
  sfxVolumePercent,
  lastAudibleMusicVolumePercent,
  lastAudibleSfxVolumePercent
}: ToggleAudioMuteOptions): AudioVolumeState {
  if (isAudioMuted({ musicVolumePercent, sfxVolumePercent })) {
    return {
      musicVolumePercent: lastAudibleMusicVolumePercent,
      sfxVolumePercent: lastAudibleSfxVolumePercent
    };
  }

  return {
    musicVolumePercent: 0,
    sfxVolumePercent: 0
  };
}
